import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Header({ logout, username, setIsLogout, userRole }) {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);



    function hiden_leftbar() {
        const htmlElement = document.querySelector('html');
        const body = document.querySelector('body');


        //Select the element using Data-ID If the ID is not present
        let divBar = document.getElementById('scrollbar') || document.querySelector('[data-id="scrollbar"]');

        if (htmlElement.getAttribute('data-sidebar-size') === 'lg') {
            htmlElement.setAttribute('data-sidebar-size', 'sm');
            body.setAttribute('class', 'twocolumn-panel');

            //Remove the ID but keep the attribute Data-ID
            if (divBar) {
                divBar.removeAttribute('id');
            }
        } else {
            htmlElement.setAttribute('data-sidebar-size', 'lg');
            body.setAttribute('class', 'twocolumn-panel vertical-sidebar-enable');

            //add the ID if the element exists
            if (divBar) {
                divBar.setAttribute('id', 'scrollbar');
            }
        }
    }



    function changeTheme() {
        const htmlElement = document.querySelector('html');
        if (htmlElement.getAttribute('data-layout-mode') === 'light') {
            htmlElement.setAttribute('data-layout-mode', 'dark');
            localStorage.setItem('DarkMode', "dark");
        } else {
            htmlElement.setAttribute('data-layout-mode', 'light');
            localStorage.setItem('DarkMode', "light");
        }
    }


    const toggleFullScreen = () => {
        const element = document.documentElement;

        if (!document.fullscreenElement) {

            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        } else {

            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }

    }


    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <header id="page-topbar">
            <div className="layout-width">
                <div className="navbar-header">
                    <div className="d-flex">
                        <button
                            type="button"
                            className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                            id="topnav-hamburger-icon"
                            onClick={() => {
                                hiden_leftbar()
                            }}
                        >
                            <span className="hamburger-icon">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </div>

                    <div className="d-flex align-items-center">

                        <div className="dropdown d-md-none topbar-head-dropdown header-item">
                            {/*   <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="bx bx-search fs-22"></i>
                            </button> */}
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                                            <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>



                        <div className="ms-1 header-item d-none d-sm-flex">
                            <button
                                type="button"
                                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none"
                                data-toggle="fullscreen"
                                onClick={toggleFullScreen}
                            >
                                <i className='bx bx-fullscreen fs-22'></i>
                            </button>
                        </div>

                        <div className="ms-1 header-item d-none d-sm-flex">
                            <button
                                type="button"
                                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none"
                                onClick={changeTheme}
                            >
                                <i className='bx bx-moon fs-22'></i>
                            </button>
                        </div>


                        <div className="dropdown ms-sm-3 header-item topbar-user">
                            <button type="button" className="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="d-flex align-items-center">
                                    {isDesktop && (
                                        <img className="rounded-circle header-profile-user" src="assets/images/dbclondon-sm.png" alt="Header Avatar" />
                                    )}

                                    <span className="text-start ms-xl-2">
                                        <h6 className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{username}</h6>
                                        <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userRole}</span>
                                    </span>
                                </span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                <h6 className="dropdown-header">Welcome {username}!</h6>
                                <Link className="dropdown-item" to="/profiles"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Profile</span></Link>
                                <button className="dropdown-item" onClick={() => {
                                    logout()
                                }}><i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span className="align-middle" data-key="t-logout">Logout</span></button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;